module.exports = __webpack_public_path__ + "static/media/StrainThreshold.0582e2c0.svg";